import { create } from "zustand";
import { persist } from "zustand/middleware";

// Persistido en localStorage como `tv_token`. Cuando hagas logout o
// el token expire, se limpia. `sub` es el id numérico del usuario en D1,
// útil para comparar "soy yo?" sin depender del nombre (no único).
export const useAuthStore = create(
  persist(
    (set) => ({
      token: null,
      sub: null,
      email: null,
      rol: null,
      nombre: null,
      local_id: null,
      local_nombre: null,

      setAuth: ({ token, sub, email, rol, nombre, local_id, local_nombre }) =>
        set({ token, sub, email, rol, nombre, local_id, local_nombre }),

      logout: () =>
        set({
          token: null, sub: null, email: null, rol: null,
          nombre: null, local_id: null, local_nombre: null,
        }),
    }),
    { name: "tv_token" }
  )
);
